// extracted by mini-css-extract-plugin
export var menuIcon = "_rp-0";
export var menuIconInline = "_rp-1";